import {lavoratoriApi} from "@commons/features/lavoratore/lavoratore.api";
import {fotoLavoratoreApi} from "@commons/features/lavoratore/fotoLavoratore.api";
import {RMLLavoratoreApi} from "@commons/features/lavoratore/RMLLavoratore.api";

/*export const lavoratoriReducers = combineReducers({
    lavoratoriApi: lavoratoriApi.reducer,
    fotoLavoratoreApi: fotoLavoratoreApi.reducer,
})*/
export const lavoratoriReducers = {
    [lavoratoriApi.reducerPath]: lavoratoriApi.reducer,
    [fotoLavoratoreApi.reducerPath]: fotoLavoratoreApi.reducer,

    [RMLLavoratoreApi.reducerPath]: RMLLavoratoreApi.reducer,
}
export const lavoratoriMiddlewares = [
    lavoratoriApi.middleware,
    fotoLavoratoreApi.middleware,

    RMLLavoratoreApi.middleware,
]